import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

const TABS = [
  { id: 'arbol', label: 'Arbol', path: '/arbol',
    icon: (c) => <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke={c} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="5" r="2.5"/><circle cx="7" cy="12" r="2"/><circle cx="17" cy="12" r="2"/><circle cx="12" cy="19" r="2"/><line x1="12" y1="7.5" x2="7" y2="10"/><line x1="12" y1="7.5" x2="17" y2="10"/><line x1="7" y1="14" x2="12" y2="17"/><line x1="17" y1="14" x2="12" y2="17"/></svg> },
  { id: 'mision', label: 'Mision', path: '/arbol?tab=mision',
    icon: (c) => <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke={c} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d="M13 2L3 14h9l-1 8 10-12h-9l1-8z"/></svg> },
  { id: 'chat', label: 'Chat', path: '/arbol?tab=chat',
    icon: (c) => <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke={c} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d="M21 11.5a8.38 8.38 0 01-.9 3.8 8.5 8.5 0 01-7.6 4.7 8.38 8.38 0 01-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 01-.9-3.8 8.5 8.5 0 014.7-7.6 8.38 8.38 0 013.8-.9h.5a8.48 8.48 0 018 8v.5z"/></svg> },
  { id: 'carta', label: 'Carta', path: '/arbol?tab=carta',
    icon: (c) => <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke={c} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="3" width="18" height="18" rx="3"/><line x1="3" y1="9" x2="21" y2="9"/><line x1="9" y1="21" x2="9" y2="9"/></svg> },
  { id: 'perfil', label: 'Perfil', path: '/arbol?tab=perfil',
    icon: (c) => <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke={c} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d="M20 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2"/><circle cx="12" cy="7" r="4"/></svg> },
];

export default function MobileTabBar({ activeTab, onTabChange }) {
  const navigate = useNavigate();
  const location = useLocation();

  const handleTab = (tab) => {
    if (onTabChange) {
      onTabChange(tab.id);
    } else {
      navigate(tab.path);
    }
  };

  // Determine which tab is active
  const searchParams = new URLSearchParams(location.search);
  const tabFromUrl = searchParams.get('tab');
  const current = activeTab || (location.pathname === '/arbol' ? (tabFromUrl || 'arbol') : null);

  return (
    <nav style={{
      position: 'fixed', bottom: 0, left: 0, right: 0,
      height: 'calc(var(--td-tabbar-height) + var(--td-safe-bottom))',
      paddingBottom: 'var(--td-safe-bottom)',
      background: 'var(--td-s1)',
      borderTop: '1px solid var(--td-border)',
      display: 'flex',
      alignItems: 'center',
      zIndex: 200,
    }}>
      {TABS.map(tab => {
        const isActive = current === tab.id;
        const color = isActive ? 'var(--td-teal)' : 'var(--td-dim)';
        return (
          <button key={tab.id} onClick={() => handleTab(tab)}
            style={{
              flex: 1, display: 'flex', flexDirection: 'column',
              alignItems: 'center', gap: 2,
              background: 'none', border: 'none', cursor: 'pointer',
              padding: '6px 0',
              WebkitTapHighlightColor: 'transparent',
            }}>
            {tab.icon(isActive ? '#5dc1b9' : '#6B7084')}
            <span style={{
              fontFamily: "'DM Sans', sans-serif",
              fontSize: 10, fontWeight: 600,
              color,
              lineHeight: 1,
            }}>{tab.label}</span>
          </button>
        );
      })}
    </nav>
  );
}
